import { React } from "react";

import Routers from "./routes";
import theme from "./styles/theme";
import { ThemeProvider } from 'styled-components';
import GlobalTheme from "./global";
import MessageProvider from "./context/message";
import PaginationProvider from "./context/paginationController";
import DataSchoolProvider from "./context/dataSchool";
import AuthProvider from "./context/auth";
import DataUtilsProvider from "./context/dataUtils";


function Root() {

    return (
        <>
            <AuthProvider>
                <MessageProvider>
                    <DataSchoolProvider>
                        <PaginationProvider>
                            <DataUtilsProvider>
                                <ThemeProvider theme={theme}>
                                    <Routers />
                                    <GlobalTheme />
                                </ThemeProvider>
                            </DataUtilsProvider>
                        </PaginationProvider>
                    </DataSchoolProvider>
                </MessageProvider>
            </AuthProvider>
        </>
    )
}
export default Root;